import { buttonVariants } from "@arcadeai/design-system/components/ui/atoms/button";
import { Link } from "@tanstack/react-router";
import type { JSX } from "react";

type OnboardingUnavailableProps = {
  organizationId: string;
  projectId: string;
};

export function OnboardingUnavailable({
  organizationId,
  projectId,
}: OnboardingUnavailableProps): JSX.Element {
  return (
    <div className="flex h-svh items-center justify-center bg-background px-6">
      <div className="max-w-md text-center">
        <h1 className="mb-6 font-semibold text-foreground text-xl">
          You don't have access to this page
        </h1>
        <Link
          className={buttonVariants()}
          params={{ organizationId, projectId }}
          to="/orgs/$organizationId/projects/$projectId/playground/chat"
        >
          Go to playground
        </Link>
      </div>
    </div>
  );
}
